import React from 'react';
import { Link } from 'gatsby';
import { Heading } from '../common/TypographyPublicSite';

const RecentPostLink = ({ slug, title }) => (
  <li>
    <Link to={slug}>{title}</Link>
  </li>
);

export default ({ recentBlogPosts = [] }) => (
  <>
    <Heading as="h2" className="title--small">
      Recent Articles
    </Heading>
    <ul className="list-links list--unstyled">
      {recentBlogPosts.map(({ id, title, slug }) => (
        <RecentPostLink key={id} {...{ slug, title }} />
      ))}
      <RecentPostLink slug="/credit-health/insights" title="More" />
    </ul>
  </>
);
